import { getForecastDateLabel } from 'features/Weather/utils/forecastDate.utils';
import useLocation from 'hooks/useLocation';
import { useGetHourlyForecastQuery } from 'services/weather/weather.api';
import WeatherCardGrid from '../../components/WeatherCardGrid/WeatherCardGrid';
import { weatherDetails } from '../../config/forecast.config';
import { getWeatherTimeString } from '../../utils/forecast.utils';

const HourlyForecast = () => {
  const { locations } = useLocation();
  const effectiveLocation = locations.effectiveLocation;
  const { data: hourlyForecast = [], isLoading: loadingHourlyForecast } =
    useGetHourlyForecastQuery(effectiveLocation);

  const pageHeading =
    getForecastDateLabel(hourlyForecast[0]?.iso8601, 'Hourly Forecast') ?? undefined;

  return (
    <WeatherCardGrid
      loading={loadingHourlyForecast}
      pageHeading={pageHeading}
      forecast={hourlyForecast}
      cardDetails={weatherDetails}
      getCardTitle={(item) => getWeatherTimeString(item?.iso8601)}
      getCardKey={(item) => item?.iso8601}
      emptyMessage="No hourly forecast data available"
    />
  );
};

export default HourlyForecast;
